var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"droppo-logo"},[_c('img',{staticClass:"droppo-logo__top",style:(_vm.hatStyle),attrs:{"src":require("../../../assets/images/logos/Smart-Point-Girona_logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }